import { render } from "./BuildHub.vue?vue&type=template&id=44cec92e&scoped=true"
import script from "./BuildHub.vue?vue&type=script&lang=js"
export * from "./BuildHub.vue?vue&type=script&lang=js"

import "./BuildHub.vue?vue&type=style&index=0&id=44cec92e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44cec92e"]])

export default __exports__